import { A } from '@solidjs/router';
import { t } from '@/shared/i18n';
import { usePublicPath } from '@/shared/lib/usePublicPath';

interface MarketingFooterProps {
  lightTheme?: boolean;
}

export default function MarketingFooter(props: MarketingFooterProps = {}) {
  const lightTheme = () => props.lightTheme ?? false;
  const pp = usePublicPath();

  return (
    <footer
      class={`relative z-10 border-t ${
        lightTheme()
          ? 'border-slate-200 bg-white/70'
          : 'border-white/20 bg-black/10'
      }`}
    >
      <div class="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <div class="flex flex-col items-center justify-between gap-4 sm:flex-row">
          <p
            class={`text-sm ${lightTheme() ? 'text-slate-600' : 'text-white/70'}`}
          >
            {t('public.footer.copyright')}
          </p>
          <div class="flex gap-6">
            <A
              href={pp('/privacy')}
              class={`text-sm ${
                lightTheme()
                  ? 'text-slate-600 hover:text-slate-900'
                  : 'text-white/70 hover:text-white'
              }`}
            >
              {t('public.footer.privacy')}
            </A>
            <A
              href={pp('/terms')}
              class={`text-sm ${
                lightTheme()
                  ? 'text-slate-600 hover:text-slate-900'
                  : 'text-white/70 hover:text-white'
              }`}
            >
              {t('public.footer.terms')}
            </A>
            <A
              href={pp('/billing-terms')}
              class={`text-sm ${
                lightTheme()
                  ? 'text-slate-600 hover:text-slate-900'
                  : 'text-white/70 hover:text-white'
              }`}
            >
              {t('public.footer.billingTerms')}
            </A>
            <a
              href="mailto:human.khoai@gmail.com"
              class={`text-sm ${
                lightTheme()
                  ? 'text-slate-600 hover:text-slate-900'
                  : 'text-white/70 hover:text-white'
              }`}
            >
              {t('public.footer.contact')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
